(function () {
    'use strict';
    var controllerId = 'tutorialVideo';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$sce', 'video', 'lingua', tutorialVideoFn]);

    function tutorialVideoFn($scope, $uibModalInstance, $sce, video, lingua) {
        $scope.video = video;
        $scope.lingua = lingua;

        $scope.video.Url = $scope.video.Url.replace("watch?v=", "embed/");        

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };      

        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        };
    }
})();